<template>
  <div class="salarii-wrapper">
    <div class="salarii-row sal-top-1">
      <div class="left-block">
        <label class="lbl ml-1">Data:</label>
        <DxSelectBox :items="luni" v-model="lunaSelectata" display-expr="text" value-expr="value" width="120"
          @value-changed="getAngajati" />

        <DxSelectBox :items="ani" v-model="anulSelectat" display-expr="text" value-expr="value" width="120"
          @value-changed="getAngajati" />

        <DxCheckBox v-model="rectificativ" text="Rectificativ" />
        <DxCheckBox v-model="veziDetalii" text="Vezi detale cu preluare automata" class="ml-3" />
      </div>

      <div class="salarii-row sal-top-2">
        <label class="lbl ml-1">Departament:</label>
        <DxSelectBox :data-source="dsDepartamente" display-expr="Name" value-expr="ID"
          placeholder="[selectați din listă]" width="690" v-model="departamentSelectat" :show-clear-button="true"
          @value-changed="onDepartamentChanged" />
      </div>

      <div class="act-btns">
        <DxButton text="Preluare date" type="default" styling-mode="contained" icon="runner" />
        <DxButton text="Calcul salarii" type="success" styling-mode="contained" icon="money" />
        <DxButton text="Simulare sal." type="default" styling-mode="contained" icon="pulldown"
          @click="simulareSalarii" />
        <DxButton text="Inchide salarii" type="danger" styling-mode="contained" icon="close" />
      </div>
      <DxRadioGroup :items="['Angajati', 'Companie']" layout="horizontal" v-model="modPreluare"
        @value-changed="onModeChanged" />
    </div>
    <div :class="{ 'disabled-grid': modPreluare === 'Companie' }">
      <DxDataGrid class="salarii-grid" :data-source="dsActiveEmployees" key-expr="Id" :show-borders="true"
        :show-row-lines="true" :row-alternation-enabled="true" :allow-column-reordering="true"
        :allow-column-resizing="true" :column-resizing-mode="'nextColumn'" :hover-state-enabled="true"
        :focused-row-enabled="true" :focused-row-index="0" :column-auto-width="false" width="100%"
        @selection-changed="onSelectionChanged">
        <DxSelection mode="single" />
        <DxFilterRow :visible="true" />
        <DxSorting mode="multiple" />
        <DxPaging :page-size="12" />

        <DxColumn data-field="InternalCode" caption="Cod" width="80" />
        <DxColumn data-field="Name" caption="Nume" />
        <DxColumn data-field="Surname" caption="Prenume" />
        <DxColumn data-field="GrupNume" caption="Grup" />
        <!-- <DxColumn data-field="DataStartVechime" caption="Data Angajarii" data-type="date" format="dd.MM.yyyy" /> -->
      </DxDataGrid>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import {
  DxDataGrid,
  DxColumn,
  DxFilterRow,
  DxSelection,
  DxSorting,
  DxPaging
} from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import DxSelectBox from 'devextreme-vue/select-box';
import DxCheckBox from 'devextreme-vue/check-box';
import DxRadioGroup from 'devextreme-vue/radio-group';
import PER_ActiveEmployees from '@/services/PER/PER_ActiveEmployees';
export default defineComponent({
  name: 'SalariiGridLikeOldWinform',
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxSelection,
    DxSorting,
    DxPaging,
    DxButton,
    DxSelectBox,
    DxCheckBox,
    DxRadioGroup
  },
  data() {
    return {
      dsDepartamente: [],
      modPreluare: 'Companie',
      departamentSelectat: null,
      dsActiveEmployees: [],
      lunaSelectata: new Date().getMonth() + 1,
      anulSelectat: new Date().getFullYear(),
      luni: [
        { text: 'Ianuarie', value: 1 },
        { text: 'Februarie', value: 2 },
        { text: 'Martie', value: 3 },
        { text: 'Aprilie', value: 4 },
        { text: 'Mai', value: 5 },
        { text: 'Iunie', value: 6 },
        { text: 'Iulie', value: 7 },
        { text: 'August', value: 8 },
        { text: 'Septembrie', value: 9 },
        { text: 'Octombrie', value: 10 },
        { text: 'Noiembrie', value: 11 },
        { text: 'Decembrie', value: 12 },
      ],
      ani: [
        { text: '2010', value: 2010 },
        { text: '2011', value: 2011 },
        { text: '2012', value: 2012 },
        { text: '2013', value: 2013 },
        { text: '2014', value: 2014 },
        { text: '2015', value: 2015 },
        { text: '2016', value: 2016 },
        { text: '2017', value: 2017 },
        { text: '2018', value: 2018 },
        { text: '2019', value: 2019 },
        { text: '2020', value: 2020 },
        { text: '2021', value: 2021 },
        { text: '2022', value: 2022 },
        { text: '2023', value: 2023 },
        { text: '2024', value: 2024 },
        { text: '2025', value: 2025 },
        { text: '2026', value: 2026 },
      ],
      rectificativ: false,
      veziDetalii: false,
    };
  },
  mounted() {
    this.getAngajati();
    this.getDepartamente();
  },
  emits: ['selection-changed'],
  methods: {
    async simulareSalarii() {
      try {
        const { startDate, endDate } = this.getIntervalLuna(this.anulSelectat, this.lunaSelectata);


        const esteCompanie = this.modPreluare === 'Companie';
        const angajatId = esteCompanie ? null : this.lastEmpId;

        const blob = await PER_ActiveEmployees.SimulareSalarii(
          startDate,
          endDate,
          angajatId,
          esteCompanie
        );

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = esteCompanie
          ? 'Simulare_Salarii_Companie.pdf'
          : 'Simulare_Salarii_Angajat.pdf';
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Eroare la simulare salarii:', error);
        alert('A apărut o eroare la generarea raportului!');
      }
    },
    getAngajati() {
      const { startDate, endOfMonth2359 } = this.getIntervalLuna(this.anulSelectat, this.lunaSelectata);

      const data1 = this.formatLocalISO(startDate);
      const data2 = this.formatLocalISO(endOfMonth2359);

      const deptId = this.departamentSelectat || null;


      PER_ActiveEmployees.get(data1, data2, deptId)
        .then((response: any) => { this.dsActiveEmployees = response.data; })
        .catch((e: Error) => console.log(e));
    },

    getIntervalLuna(an: number, luna: number) {

      const startDate = new Date(an, luna - 1, 1, 0, 0, 0);

      const endOfMonth2359 = new Date(an, luna, 0, 23, 59, 0);

      return { startDate, endOfMonth2359 };
    },

    formatLocalISO(d: Date) {
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },


    getDepartamente() {
      PER_ActiveEmployees
        .getDepartamente()
        .then((response: any) => {
          this.dsDepartamente = response.data;
        })
        .catch((e: Error) => console.log(e));
    },
    onSelectionChanged(e) {
      const row = e.selectedRowsData?.[0]
      if (!row) return

      const empId =
        row.empId ||
        row.EmpId ||
        row.employeeId ||
        row.EmployeeId ||
        row.ID ||
        row.Id ||
        null

      this.lastEmpId = empId

      this.$emit('selection-changed', {
        empId,
        mode: this.modPreluare
      })
    },
    onModeChanged(e) {
      this.$emit('selection-changed', {
        empId: this.lastEmpId || null,
        mode: this.modPreluare
      })
    },
    onDepartamentChanged(e) {
      // valoarea selectată e în e.value
      this.departamentSelectat = e.value || null;
      this.getAngajati();
    },


  }
});
</script>

<style scoped>
.disabled-grid {
  pointer-events: none;
  /* blochează interacțiunea */
  opacity: 0.5;
  /* face gri vizual */
  filter: grayscale(70%);
}

.salarii-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding: 10px;
  background: #f2f4f7;
  border: 1px solid #c7cdd5;
  font-size: 13px;
}

.salarii-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 10px 0;
  /* 20px sus și jos, 0 stânga-dreapta */
}

.left-block {
  display: flex;
  align-items: center;
  gap: 8px;
}

.act-btns {
  display: flex;
  gap: 30px;
  margin: 0 0;
  /* 20px sus și jos, 0 stânga-dreapta */
}

.salarii-grid {
  flex: 1;
  width: 100%;
  border: 1px solid #9db0d4;
  box-sizing: border-box;
}
::v-deep .salarii-grid .dx-datagrid-rowsview .dx-row > td {
  height: 10px;
  padding: 8px 6px;
}

/* header albastru */
.salarii-grid .dx-datagrid-headers {
  background: #3b5485;
  color: #fff;
  font-weight: 600;
  border-bottom: 1px solid #2f446a;
}

/* alternanta */
.salarii-grid .dx-row-alt {
  background: #f6f8fb;
}

/* rand selectat */
.salarii-grid .dx-datagrid-rowsview .dx-selection,
.salarii-grid .dx-datagrid-rowsview .dx-row-focused {
  background: #27406b !important;
  color: #fff;
}

/* rand filtru */
.salarii-grid .dx-datagrid-filter-row td {
  background: #dfe4ee;
  border-bottom: 1px solid #c6cfde;
}

.salarii-grid .dx-datagrid-filter-row .dx-editor-with-menu .dx-texteditor-input {
  height: 26px;
  font-size: 12px;
}

/* celule compacte */
.salarii-grid .dx-data-row td {
  padding: 4px 6px;
  font-size: 13px;
}

/* iconite albe in header */
.salarii-grid .dx-datagrid-headers .dx-sort,
.salarii-grid .dx-datagrid-headers .dx-header-filter {
  color: #fff;
}

.dx-datagrid-rowsview .dx-row > td {
  height: 50px; /* setezi ce valoare vrei */
  padding-top: 10px;
  padding-bottom: 10px;
}


</style>
